import { func } from "prop-types";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Util from "pages/Dashboard/Common/Util";
import { getBusinessList, patchBusinessList, postCollectData, postMyContract, postPaymentData, setNewBusinessList } from "crud/auth.crud";

import _ from "lodash";
import moment from "moment";

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";

const ReportList = () => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()

  const [dataList, setDataList] = useState([]);
  const [sumList, setSumList] = useState([]);
  const [pricePerL, setPricePerL] = useState(50);
  const [user, setUser] = useState(selector.auth?.user);
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [companyDetail, setCompanyDetail] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]);
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM') + '-01 00:00:00');
  const [endDate, setEndDate] = useState(moment(nextDate.setMonth(nextDate.getDate() + 1)).format('YYYY-MM') + '-01 00:00:00');
  const [modalShow, setModalShow] = useState(false);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [size, setSize] = useState(4);
  const [totalElements, setTotalElements] = useState(4);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [companyListFile, setCompanyListFile] = useState(undefined);
  const [onUpload, setOnUpload] = useState(false);
  const [totalState, setTotalState] = useState('Y')
  const [totalPrice, setTotalPrice] = useState(0)
  const [totalSum, setTotalSum] = useState(0)

  const getCollectDataSum = async (dataList) => {
    try {
      let tmp = []
      for (let i = 0; i < dataList.length; i++) {
        if(dataList[i].id !== company)
        tmp.push(dataList[i].id)
      }
      tmp.push(company)
      const params = {
        ids: JSON.stringify(tmp),
        start_ym: startDate,
        end_ym: endDate,
      }
      const response = await postPaymentData(params);
      if (response.data?.result === 'success') {
        const dataList = response?.data?.data;
        let sum = 0
        let totalPrice = 0
        let totalState = 'Y'
        for(let i=0; i < dataList.length; i++){
          sum = sum + (dataList[i].total_qty_l || 0);    
          totalPrice = totalPrice + (dataList[i].total_payment_price || 0); 
          if(dataList[i].state === 'N' && totalPrice > 0) totalState = 'N'
        }
        setSumList(dataList)
        setTotalSum(sum)
        setTotalPrice(totalPrice)
        setTotalState(totalState)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDataList = async () => {
    try {
      const response = await getBusinessList(`?id=${company}`);
      if (response.data?.result === 'success') {
        let dataList = response?.data?.data?.filter(itm => itm.id !== company);
        let myData = response?.data?.data?.filter(itm => itm.id === company)
        setDataList([...myData, ...dataList])
        getCollectDataSum([...myData, ...dataList])
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getDataList()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>청구서 | 웨이스트버스</title>
        </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs maintitle="Home" breadcrumbItem="청구서" />

            <Row>
              <Col xs="12" xl='8'>
              <div className="email-rightbar mb-3">
                <Card className="overflow-hidden">
                  <div className="radius-4 overflow-hidden">
                    <div className="table-responsive">
                      <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">업체명</th>
                            <th scope="col">배출량(L)</th>
                            <th scope="col">정산금액(원)</th>
                            <th scope="col">정산여부</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">

                      {dataList && dataList.map((item, index) => {
                        const sumData = sumList.filter(itm => itm.id === item.id)?.[0]
                        const sum = sumData?.total_qty_l || 0;
                        const money = sumData?.total_payment_price || 0;
                        const state = sumData?.state !== 'Y' && money > 0 ? 'N' : 'Y';
                        return (
                          <>
                          {index === 0 &&
                            <tr style={{cursor: "pointer"}} 
                            onClick={()=>{
                              if(companyDetail?.is_payment_total !== 'Y'){
                                history.push({pathname: '/settlement-details', state: {companyId: item.id, companyName: '전체'}})
                              }else{
                                companyDetail?.is_payment_total === 'Y' ? history.push('/emitter-bill-all') : history.push('/emitter-bill')
                              }
                            }}>
                              <td>{'전체'}</td>
                              <td>{Util.setPrice(totalSum)}</td>
                              <td>{Util.setPrice(totalPrice)}</td>
                              <td>{totalState !== 'Y' ? '미정산' : '완납'}</td>
                            </tr>
                          }
                          <tr key={item.id + '_' + index} style={{cursor: "pointer"}} 
                          onClick={()=>{
                            if (company !== item.id || companyDetail?.is_payment_total === 'Y') {
                              history.push({ pathname: '/settlement-details', state: { companyId: item.id, companyName: item.name } })
                            } else {
                              companyDetail?.is_payment_total === 'Y' ? history.push('/emitter-bill-all') : history.push('/emitter-bill')
                            }
                          }}>
                            <td>{item.name}</td>
                            <td>{Util.setPrice(sum)}</td>
                            <td>{Util.setPrice(money)}</td>
                            <td>{state !== 'Y' ? '미정산' : '완납'}</td>
                          </tr>
                          </>
                        )
                      })}

                        </tbody>
                      </table>
                    </div>
                  </div>
                </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      {onUpload && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default ReportList